import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import JobDetail from './pages/JobDetail';

const JobWrapper = () => {
  return (
    <Switch>
      <Route exact path={ROUTES?.JOBS} />
      <Route path={`${ROUTES?.JOBS}/create`} component={JobDetail} />
      <Route path={`${ROUTES?.JOBS}/:id/edit`} component={JobDetail} />
      <Route path={`${ROUTES?.JOBS}/:id`} component={JobDetail} />
    </Switch>
  );
};

export default JobWrapper;
